<p-toast position="{{smallScreen ? 'bottom-right' : 'bottom-right'}}"></p-toast>

<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton accesskey="n" icon="pi pi-fw pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog #warning key="alert">
  <p-footer>
     <button type="button" pButton icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="OK" (click)="warning.accept()"></button>
  </p-footer>
</p-confirmDialog>

<div class="p-m-0 p-p-0 projects-page">
  <p-toolbar>
    <div class="p-toolbar-group-left project-toolbar">
      <!-- Display breadcrumb only on bigger than md screens-->
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>

      <span style="padding-top:2px;">
        <button *ngIf="canViewProject()"
                (click)="loadProjects()"
                pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh"></button>

        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button *ngIf="canCreateProject()" 
                  (click)="openProjectForm(null)"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="New" 
                  icon="pi-fw fas fa-plus-circle"></button>

          <button *ngIf="canExportProject()" 
                  (click)="exportProject()"
                  [disabled]="exporting"
                  pButton type="button" 
                  class="p-button p-button-text"
                  label="Excel Report" 
                  icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"></button>

          <button *ngIf="canModifyProject()" 
                  (click)="openProjectForm(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Edit" 
                  icon="pi-fw fas fa-edit"></button>

          <button *ngIf="canDeleteProject()" 
                  (click)="deleteProject(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Delete" 
                  icon="pi-fw fas fa-trash-alt"></button>

          <button *ngIf="canCreateProjectInvoice()" 
                  (click)="addInvoice(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Create Invoice" 
                  icon="pi-fw fas fa-file-invoice-dollar"></button>

          <p-button *ngIf="canViewProjectInvoice()" 
                  (click)="viewProjectInvoices(selectedRow)"
                  [disabled]="!(selectedRow && selectedRow.invoices && selectedRow.invoices.length > 0)"
                  [styleClass]="'p-button p-button-text'" 
                  label="View Invoices" 
                  icon="pi-fw fas fa-search-dollar"
                  badge="{{selectedRow && selectedRow.invoices ? selectedRow.invoices.length : 0}}" 
                  badgeClass="{{selectedRow && selectedRow.invoices.length > 0 ? 'p-badge-success' : 'hide'}}">
          </p-button>
          <!-- <p-badge [value]="selectedRow && selectedRow.invoices ? selectedRow.invoices.length : 0" severity="danger"></p-badge> -->
          <button *ngIf="canViewTimeSheet()" 
                  (click)="viewProjectTimesheet(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Timesheet" 
                  icon="pi-fw fas fa-user-clock"></button>

          <p-checkbox [(ngModel)]="activeProjectsOnly" 
                      [binary]="true" 
                      (onChange)="loadProjects()"
                      label="Active Project"></p-checkbox>
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button *ngIf="canCreateProject()" 
                  (click)="openProjectForm(null)"
                  pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-plus-circle"></button>

          <button *ngIf="canExportProject()" 
                  (click)="exportProject()"
                  pButton type="button" 
                  class="p-button-rounded p-button-success"
                  icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"></button>

          <button *ngIf="canModifyProject()" 
                  (click)="openProjectForm(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-edit"></button>

          <button *ngIf="canDeleteProject()" 
                  (click)="deleteProject(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded p-button-danger" 
                  icon="pi-fw fas fa-trash-alt"></button>

          <button *ngIf="canCreateProjectInvoice()" 
                  (click)="addInvoice(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-file-invoice-dollar"></button>

          <p-button *ngIf="canViewProjectInvoice()" 
                  (click)="viewProjectInvoices(selectedRow)"
                  [disabled]="!(selectedRow && selectedRow.invoices && selectedRow.invoices.length > 0)"
                  [styleClass]="'p-button-rounded p-button-success'" 
                  icon="pi-fw fas fa-search-dollar"></p-button>

          <button *ngIf="canViewTimeSheet()" 
                  (click)="viewProjectTimesheet(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-user-clock"></button>
        </span>
      </span>
    </div>
    
    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
          severity="info"
          pTooltip="Total number of projects: {{projects.length}}"
          tooltipPosition="left"
          value="{{projects.length}}"></i>
    </div>
  </p-toolbar>

  <div class="projects-grid-area">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false">

      <p style="color:white" >Loading projects... </p>
    </ngx-spinner>

        <ag-grid-angular #topGrid
                    *ngIf="canViewProject()"
                                        class="ag-theme-alpine pps-top-grid projects-top-grid"
                    [rowData]="projects"
                    [columnDefs]="gridHeaders"
                    [context]="context"
                    [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
                    [tooltipShowDelay]="0"
                    [gridOptions]="topOptions"
                    (firstDataRendered)='onFirstDataRendered($event)'
                    (cellDoubleClicked)="onCellDblClicked($event)"
                    [overlayNoRowsTemplate]="'<span> </span>'"
                    (gridReady)="onTopGridReady($event)">
    </ag-grid-angular>
        <ag-grid-angular #bottomGrid
                    *ngIf="canViewProject()"
                                        class="ag-theme-alpine pps-bottom-grid projects-bottom-grid"
                    [headerHeight]="0"
                    [context]="context"
                    [rowData]="projectTotal"
                    [columnDefs]="gridHeaders"
                    [gridOptions]="bottomOptions"
                    (gridReady)="onBottomGridReady($event)"
                    [rowStyle]="{ fontWeight: 'bold', backgroundColor: '#eeeeee'}"
                    [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
    </ag-grid-angular>
  </div>
</div>